const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class StripeReconciliationConnector {
  constructor(configuration, tokenManager) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);

    this.tokenManager = tokenManager;
  }

  async reconciliatePayoutReport({ instanceId, reportId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/stripe/reports/reconciliation/${instanceId}/${reportId}`,
        method: 'POST',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getOptions() {
    if (!this.tokenManager) {
      return {};
    }

    const token = await this.tokenManager.getToken();
    return {
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    };
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  StripeReconciliationConnector,
};
